import { Record, List } from 'immutable';
import moment from 'moment';

export const DashboardRecord = Record({
  tableData: List([]),
  graphData: List([]),
});

export const GraphFilters = Record({
  filters: List([]),
  start_date: moment(),
  end_date: moment(),
  client_domain: null,
  granularity: 'day',
});
